module.exports = __webpack_public_path__ + "img/top-logo.962a97de.jpg";